<template>
    <div>
        <loading :active.sync="is_loading" :can-cancel="true" :is-full-page="true">
        </loading>
        <!-- Navbar -->
        <Navbar />

        <!-- Sidebar -->
        <SidebarConservation />

        <main id="main" class="main">
            <!-- Breadcomp -->
            <Breadcrumb :links="links" />
            <!-- END OF BREADCOMP -->

            <section class="section dashboard overflow-visible">
                <div class="row">
                    <!-- Left side columns -->
                    <div class="col-lg-12">
                        <div class="row">
                            <!-- Recent Sales -->
                            <div class="col-sm-12">
                                <div class="card overflow-visible">
                                    <div class="card-body">
                                        <div class="row mb-3">
                                            <div class="col-lg-2">
                                                <select v-model="year" class="form-select">
                                                    <option v-for="(y, i) in range(year_start, year_end)" :value="y" :key="i">{{ y }}</option>
                                                </select>
                                            </div>
                                            <div class="col-lg-2">
                                                <button class="btn btn-primary" @click="() => getData(1)"><i class="fa fa-filter"></i> filter</button>
                                            </div>
                                            <div class="col-lg-8 text-end">
                                                <button class="btn btn-warning me-2" @click="openDownloadModal">
                                                    <i class="fa fa-download"></i> Export XLSX
                                                </button>
                                                <router-link to="/registration/create" class="btn btn-success">
                                                    <i class="fa fa-plus"></i> Tambah data registrasi
                                                </router-link>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <table class="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th rowspan="2">Tahun</th>
                                                            <th rowspan="2">Lokasi</th>
                                                            <th rowspan="2">Jenis Tanaman</th>
                                                            <th rowspan="2">Unit Wilayah</th>
                                                            <th rowspan="2">Wilayah Sungai</th>
                                                            <th colspan="2">Koordinat</th>
                                                            <th rowspan="2">Jumlah</th>
                                                            <th rowspan="2"></th>
                                                        </tr>
                                                        <tr>
                                                            <th>Longitude</th>
                                                            <th>Latitude</th>
                                                        </tr>
                                                    </thead>
                                                    <template v-if="Object.keys(data.data).length > 0">
                                                        <tbody v-for="(rows, tahun) in data.data" :key="tahun">
                                                            <tr v-for="(row, index) in rows" :key="row.id">
                                                                <td :rowspan="rows.length" v-if="index === 0">{{ tahun }}</td>
                                                                <td>{{ row.lokasi }}</td>
                                                                <td>{{ row.jenis_tanaman }}</td>
                                                                <td>{{ row.unit_wilayah }}</td>
                                                                <td>{{ row.wilayah_sungai }}</td>
                                                                <td>{{ row.lng }}</td>
                                                                <td>{{ row.lat }}</td>
                                                                <td>{{ row.jumlah }}</td>
                                                                <td>
                                                                    <router-link :to="`/registration/${row.id}/edit`" class="btn btn-sm btn-primary me-2">
                                                                        <i class="fa fa-pen"></i>
                                                                    </router-link>
                                                                    <button class="btn btn-sm btn-danger" @click="removeRow(row.id)">
                                                                        <i class="fa fa-trash"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                    <template v-else>
                                                        <tbody>
                                                            <tr>
                                                                <td colspan="8" class="text-center"><i>belum ada data tahun {{ year }}</i></td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </table>
                                            </div>
                                        </div>
                                        <nav aria-label="Page navigation example">
                                            <ul class="pagination">
                                                <li v-for="page in data.meta.pageCount" class="page-item" :class="page === data.meta.currentPage ? 'active':''" :key="page">
                                                    <a class="page-link" href="#" @click.prevent="() => getData(page)">{{ page }}</a>
                                                </li>
                                            </ul>
                                        </nav>
                                        <div class="position-relative">
                                            <GmapMap
                                                :center="{lat:this.lat, lng:this.lng}"
                                                :zoom="9"
                                                map-type-id="terrain"
                                                style="width: 100%; height: 800px"
                                                ref="peta">
                                                <GmapMarker
                                                    v-for="marker in map_data"
                                                    :key="marker.id"
                                                    :clickable="true"
                                                    :position="{lat: parseFloat(marker.lat), lng:parseFloat(marker.lng)}"
                                                    :icon="defineIcon()"
                                                    :title="defineMarkerIcon(marker)"
                                                    @click="showMarkerDetail(marker)"
                                                >
                                                </GmapMarker>
                                            </GmapMap>
                                            <div class="position-absolute p-3 bg-light" style="bottom: 30px; right: 30px; z-index: 9; width: 300px;">
                                                <h4>Legenda</h4>
                                                <table class="table">
                                                    <tbody>
                                                        <tr>
                                                            <td width="10%"><div title="marker-size-sm"></div></td>
                                                            <td>&lt; 1000 tanam</td>
                                                        </tr>
                                                        <tr>
                                                            <td><div title="marker-size-md"></div></td>
                                                            <td>&lt; 10.000 tanam</td>
                                                        </tr>
                                                        <tr>
                                                            <td><div title="marker-size-lg"></div></td>
                                                            <td>&gt; 10.000 tanam</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <b-modal title="Detail Registrasi" ref="marker_detail_modal" :hide-footer="true">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <th>Tahun</th>
                        <td>{{ marker_detail.tahun }}</td>
                    </tr>
                    <tr>
                        <th>Lokasi</th>
                        <td>{{ marker_detail.lokasi }}</td>
                    </tr>
                    <tr>
                        <th>Unit Wilayah</th>
                        <td>{{ marker_detail.unit_wilayah }}</td>
                    </tr>
                    <tr>
                        <th>Wilayah Sungai</th>
                        <td>{{ marker_detail.wilayah_sungai }}</td>
                    </tr>
                    <tr>
                        <th>Jenis Tanaman</th>
                        <td>{{ marker_detail.jenis_tanaman }}</td>
                    </tr>
                    <tr>
                        <th>Jumlah</th>
                        <td>{{ marker_detail.jumlah.toLocaleString() }}</td>
                    </tr>
                </tbody>
            </table>
        </b-modal>
        <b-modal title="Download XLSX" ref="download_xlsx" :hide-footer="true">
            <div class="row mb-3">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label for="">Mulai</label>
                        <select v-model="ys" class="form-select">
                            <option v-for="(y, i) in range(year_start, year_end)" :value="y" :key="i">{{ y }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label for="">Hingga</label>
                        <select v-model="ye" class="form-select">
                            <option v-for="(y, i) in range(year_start, year_end)" :value="y" :key="i">{{ y }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <button class="btn btn-primary" @click="downloadXlsx">Download XLSX</button>
        </b-modal>
    </div>
</template>
  
<script>
    // import
    import Loading from 'vue-loading-overlay'
    import Breadcrumb from '../../../components/Breadcrumb.vue'
    // Component
    import Navbar from '../../../components/Navbar.vue'
    import SidebarConservation from '../../../components/SidebarConservation.vue'
    import axios from 'axios'; // eslint-disable-line no-unused-vars
    import moment from 'moment';
    import _ from 'lodash'
    import { BModal } from 'bootstrap-vue'

    export default{
        name: 'RegistrationIndex',
        data(){
            return{
                // Need
                is_loading: false,
                links: [
                    {url: '/dashboard', text:'Home'}, 
                    {url: '/bendungan', text: 'Bendungan'}, 
                ],
                year: new Date().getFullYear(),
                year_start: new Date().getFullYear() - 20,
                year_end: new Date().getFullYear() + 1,
                per_page: 10,
                data: {
                    data: {},
                    meta: {}
                },
                lat: -6.5341128, 
                lng: 107.3428813,
                map_data: [],
                marker_detail: {
                    jumlah: 0
                },
                ys: new Date().getFullYear() - 1,
                ye: new Date().getFullYear()
            }
        },
        mounted(){
            this.getData(null);
            this.getMapData();
        },
        methods: {
            range(start, end){
                return _.range(start, end);
            },
            async getData(page){
                this.is_loading = true;

                try {
                    const response = await axios.get(`${this.$endpoints.conservation}/registrations`, {
                        params:{
                            tahun: this.year,
                            per_page: this.per_page,
                            page
                        }
                    })
                    this.data = response.data;
                } catch (error) {
                    console.error(error);
                }

                this.is_loading = false;
            },
            async getMapData(){
                try {
                    const response = await axios.get(`${this.$endpoints.conservation}/registrations/map`)
                    this.map_data = response.data;
                } catch (error) {
                    console.error(error);
                }
            },
            defineIcon: () => {
                return require('../../../assets/marker/transparent.png');
            },
            defineMarkerIcon: (marker) => {
                let size = '';
                if(marker.jumlah < 1000) {
                    size = 'sm';
                }else if(marker.jumlah > 1000 && marker.jumlah < 10000){
                    size = 'md';
                }else{
                    size = 'lg'
                }

                return `marker-size-${size}`;
            },
            showMarkerDetail(marker){
                this.marker_detail = marker;
                this.$refs.marker_detail_modal.show();
            },
            removeRow(id){
                this.$swal.fire({
                    title: "Hapus data ini?",
                    icon: "question",
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: `Yes`,
                    cancelButtonText: `Cancel`
                }).then(async (result) => {
                    if(result.isConfirmed) {
                        this.is_loading = true;

                        try {
                            await axios.delete(`${this.$endpoints.conservation}/registrations/${id}`);

                            this.$swal('Success', 'data berhasil dihapus', 'success');
                            this.getData();
                            
                        } catch (error) {
                            console.error(error);
                            this.$swal('Error', 'data gagal dihapus', 'error');
                        }

                        this.is_loading = false;
                    }
                });
            },
            openDownloadModal(){
                this.$refs.download_xlsx.show();
            },
            async downloadXlsx(){
                this.is_loading = true;

                try {
                    const response = await axios.get(`${this.$endpoints.conservation}/registrations/xlsx`, {
                        responseType: 'blob',
                        params: {
                            year_start: this.ys,
                            year_end: this.ye
                        }
                    });

                    const blob = new Blob([response.data]);
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'Rekapitulasi Program Konservasi.xlsx';
                    link.click();

                    this.$refs.download_xlsx.hide();
                } catch (error) {
                    console.error('Gagal download file:', error.message);
                }

                this.is_loading = false;
            }
        },
        filters: {
            date(value){
                return moment(value).format("DD MMM YYYY HH:mm")
            }
        },
        components:{
            Navbar,
            SidebarConservation,
            Loading, 
            Breadcrumb,
            BModal
        },
    }
</script>